import { AmplitudeExperimentContext, AmplitudeExperimentContextType } from '@/hooks/useAmplitudeExperiment';
import { useContext } from 'react';

// Inferring P from `ComponentType<P & AmplitudeExperimentContextType>` doesn't reliably decompose
// back out when the wrapped component's own prop type is itself an intersection — TS can collapse
// P to {}/unknown, silently dropping the wrapped component's own props from the exposed type.
// Inferring P as the wrapped component's whole prop type instead, then subtracting the injected
// keys for the HOC's own exposed props, sidesteps that.
function withAmplitudeExperiment<P extends AmplitudeExperimentContextType>(WrappedComponent: React.ComponentType<P>) {
  const WithAmplitudeExperiment = (props: Omit<P, keyof AmplitudeExperimentContextType>) => {
    const { getVariant, initialize } = useContext(AmplitudeExperimentContext);
    return <WrappedComponent {...(props as P)} getVariant={getVariant} initialize={initialize} />;
  };
  return WithAmplitudeExperiment;
}

export default withAmplitudeExperiment;
